import { render, staticRenderFns } from "./packageConfig.vue?vue&type=template&id=15d21537&scoped=true"
import script from "./packageConfig.vue?vue&type=script&lang=js"
export * from "./packageConfig.vue?vue&type=script&lang=js"
import style0 from "./packageConfig.vue?vue&type=style&index=0&id=15d21537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d21537",
  null
  
)

export default component.exports